import type { ContentPack } from "../_types";

/** Small, always-needed subset (hero/trust/why-us) — safe to ship in the shared bundle. */
export type ProvinceContentCore = Pick<
  ContentPack,
  "localCharacter" | "heroHeadline" | "heroSubheadline" | "trustStrip" | "whyUsLocal"
>;

export const PHUKET_CONTENT_CORE: ProvinceContentCore = {
  localCharacter:
    "ภูเก็ต = ฮับท่องเที่ยวระดับโลก + Marina/Yacht Hub + แหล่งลงทุนวิลล่าต่างชาติ (รัสเซีย-จีน-ยุโรป) + Digital Nomad ราไวย์-ในหาน + Retirement Visa ลูกค้าหลักคือ นักลงทุนอสังหา, เจ้าของโรงแรม/เรือยอร์ช, นักท่องเที่ยวต้องการเอกสารด่วน, Expat ครอบครัว, และคู่รักไทย-ต่างชาติ",

  heroHeadline: "Notary Public ภูเก็ต — ทนายรับรองเอกสารครบ 3 อำเภอ",
  heroSubheadline:
    "สำนักงานป่าตอง ทนาย Notarial Services Attorney 6 ท่าน รับ-ส่งเอกสารถึงที่ทั่วภูเก็ต ครอบคลุมนักลงทุนวิลล่ากะทู้, เจ้าของเรือยอร์ชอ่าวฉลอง, Digital Nomad ราไวย์-ในหาน, นักท่องเที่ยวรัสเซีย-จีน และเชื่อมต่อ MFA + สถานทูตแทนคุณ",

  trustStrip: [
    "ครอบคลุม 3 อำเภอภูเก็ต + พังงา + กระบี่",
    "ทนาย Notarial Services Attorney 6 ท่านขึ้นทะเบียนสภาทนายความฯ",
    "ตอบกลับ LINE ภายใน 30 นาที | เปิดทุกวัน 08:00–20:00",
    "Mobile Service ถึงป่าตอง-ราไวย์-อ่าวฉลอง-ถลาง ในวันเดียว",
    "เชื่อม MFA กรุงเทพ + สถานทูตทุกประเทศ — ลูกค้าไม่ต้องบินไปเอง",
    "ทนาย Notarial Services Attorney ขึ้นทะเบียนสภาทนายความฯ",
  ],

  whyUsLocal: [
    {
      title: "เข้าใจนักลงทุนวิลล่า-คอนโดภูเก็ตที่สุด",
      desc: "ทีมสื่อสารอังกฤษ-รัสเซีย-จีนได้ ดูแลสัญญาซื้อ-ขายวิลล่า สัญญาเช่า 30 ปี และเอกสารประกอบคำขอ BOI ให้นักลงทุนเป็นประจำ ครอบคลุมป่าตอง ราไวย์ ล็อคปาล์ม Boat Avenue และ Laguna",
    },
    {
      title: "เครือข่าย ตม.ภูเก็ต (เทพกระษัตรี) แน่น",
      desc: "เอกสาร 90-day report, Re-entry, Non-O, Retirement, DTV Visa, BOI เราดำเนินการเองที่ ตม.ภูเก็ต — รับรองเร็วกว่าเดินไปเอง ประหยัดเวลาลูกค้าเฉลี่ย 4 ชั่วโมง/เคส",
    },
    {
      title: "เชื่อม MFA กรุงเทพแทนคุณ ไม่ต้องบินไป",
      desc: "ส่งเอกสารทุกวันจันทร์-ศุกร์ มีรอบเร่งด่วน 1-2 วันทำการ ลูกค้าภูเก็ตประหยัดค่าตั๋วเครื่องบิน + เวลาทำงานเฉลี่ย 8,000 บาท/เคส",
    },
    {
      title: "รองรับ Yacht Owner อ่าวฉลอง-มารีน่า",
      desc: "รับรองสัญญาเช่าเรือยอร์ช ใบอนุญาตเดินเรือ เอกสารประกันภัยทางทะเล และ Crew Visa สำหรับเจ้าของเรือต่างชาติใน Royal Phuket Marina และ Boat Lagoon — ทีมเดียวในภูเก็ตที่รับงาน niche นี้",
    },
    {
      title: "Marriage Registration ที่อำเภอเมืองภูเก็ต",
      desc: "เตรียม Affidavit จากสถานทูต + แปล MoJ + รับรอง MFA + นัดสำนักทะเบียนอำเภอเมืองภูเก็ตครบในแพ็กเกจเดียว — มีคู่รักผ่านมือเรา 300+ คู่/ปี ส่วนใหญ่เป็นไทย-รัสเซีย ไทย-จีน ไทย-ยุโรป",
    },
    {
      title: "บริการเร่งด่วน 24 ชม.สำหรับนักท่องเที่ยวรัสเซีย-จีน",
      desc: "แปลรัสเซีย-จีนรับรอง + Notary + MFA Express + DHL ภายใน 12-24 ชั่วโมง สำหรับเอกสารการรักษาพยาบาลจากโรงพยาบาลกรุงเทพภูเก็ต / วชิระ ก่อนบินกลับ",
    },
  ],

};
